<template>
  <v-container>
    <image-with-border-dialog ref="imageWithBorderDialog"/>

    <image-upload-dialog
        :object-id="geotagId"
        path="geotagImage"
        @addNew="uploadImage"
    />

    <v-col cols="6">
      <media-images-table
          :items.sync="geotagImages"
          :object-id="geotagId"
          path="geotagImage"
          :enable-move="false"
      />
    </v-col>
  </v-container>
</template>

<script>

import { mapActions } from 'vuex';
import ImageUploadDialog from '@/components/dialogs/ImageUploadDialog.vue';
import ImageWithBorderDialog from '@/components/dialogs/ImageWithBorderDialog.vue';
import MediaImagesTable from '@/components/MediaImagesTable.vue';

export default {
  name: 'MediaGeotagImages',
  components: { MediaImagesTable, ImageWithBorderDialog, ImageUploadDialog },
  props: {
    geotagId: {
      type: Number,
    },
  },
  data() {
    return {
      geotagImages: [],
      itemClone: {},
    };
  },
  created() {
    this.getGeotagImages(this.geotagId);
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    getGeotagImages(geotagId) {
      this.$requestHelpers
        .get(`api/admin/geotagImage/list/${geotagId}`)
        .then((response) => {
          this.geotagImages = response.data.result;
        });
    },

    uploadImage(response, isSuccess) {
      if (isSuccess) {
        this.geotagImages.push(response.data.result);
      }

      return true;
    },
  },

  watch: {
    geotagId(newValue) {
      this.getGeotagImages(newValue);
    },
  },
};

</script>
<style scoped>
</style>
